// extracted by mini-css-extract-plugin
export default {"about":"About_about__yUZyc","filter_skills":"About_filter_skills__+4PNI","active":"About_active__dZ2GB","row_skils":"About_row_skils__XydcU","hide":"About_hide__AE5O1"};